import { css } from "@emotion/css";
import { ValueRem } from "./Value";

const LayoutChild: React.FC<{
  size?: ValueRem;
  grow?: number;
  shrink?: number;
}> = (props) => {
  return (
    <div
      className={css`
        label: LayoutChild;
        flex-grow: ${props.grow ?? 0};
        flex-shrink: ${props.shrink ?? (props.size == null ? 1 : 0)};
        flex-basis: ${props.size};
        width: ${props.size};
        height: ${props.size};
        line-height: 0;
      `}
    >
      {props.children}
    </div>
  );
};

export default LayoutChild;
